import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import HomePage from "./pages/HomePage";
import ProgramsPage from "./pages/ProgramsPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import DifferencePage from "./pages/DifferencePage";
import ReturningFamiliesPage from "./pages/ReturningFamiliesPage";
import DiplomaPage from "./pages/DiplomaPage";
import AdmissionsPage from "./pages/AdmissionsPage";
import TuitionPage from "./pages/TuitionPage";
import AboutPage from "./pages/AboutPage";
import PartnershipsPage from "./pages/PartnershipsPage";
import ContactPage from "./pages/ContactPage";
import EventsPage from "./pages/EventsPage";
import PrivacyPage from "./pages/PrivacyPage";
import FAQPage from "./pages/FAQPage";
import CookieBanner from "./components/layout/CookieBanner";

function App() {
  return (
    <HelmetProvider>
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/difference" element={<DifferencePage />} />
          <Route path="/returning-families" element={<ReturningFamiliesPage />} />
          <Route path="/diploma" element={<DiplomaPage />} />
          <Route path="/admissions" element={<AdmissionsPage />} />
          <Route path="/tuition" element={<TuitionPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/partnerships" element={<PartnershipsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/faq" element={<FAQPage />} />
        </Routes>
        <CookieBanner />
        <Toaster />
      </BrowserRouter>
    </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
